import React, { useState } from 'react';
import useCustomNavigate from '../../hooks/useCustomNavigate';
import { verifyOtp } from '../../services/userService';

const OtpPage = ({ }) => {
  const { goTo } = useCustomNavigate();

  const [otp, setOtp] = useState(['', '', '', '']);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return; // Allow only single digit

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Automatically move to the next input if a digit is entered
    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }

    // Clear the error message when the user starts typing
    setErrorMessage('');
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join('');

    if (otpValue.length === 4) {
      try {
        setLoading(true);
        const data = { mobile: "1234567890", otp: otpValue }; // Replace with actual mobile number
        const response = await verifyOtp(data);

        setLoading(false);

        if (response.success) {
          // OTP verification successful
          setIsModalOpen(false);
          // setIsLogin(true);
          goTo('/');
        } else {
          // Show error message if OTP verification fails
          setErrorMessage(response.message || 'Invalid OTP.');
        }
      } catch (error) {
        setLoading(false);
        setErrorMessage(
          error.response?.data?.message || 'Something went wrong. Please try again.'
        );
      }
    } else {
      setErrorMessage('Please enter a valid 4-digit OTP.');
    }
  };

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="w-full max-w-sm p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-bold text-center text-gray-700">Enter OTP</h2>
            <p className="text-sm text-center text-gray-500">
              We've sent a 4-digit OTP to your mobile number.
            </p>
            <form onSubmit={handleSubmit} className="mt-6 flex flex-col items-center">
              <div className="flex justify-between gap-2 mb-4">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    value={digit}
                    onChange={(e) => handleChange(e.target.value, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    maxLength={1}
                    className="w-12 h-12 text-center text-xl text-gray-700 bg-gray-100 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                ))}
              </div>
              {/* Error Message */}
              {errorMessage && (
                <p className="text-sm text-red-500 mb-4">{errorMessage}</p>
              )}
              <button
                type="submit"
                className={`w-full px-4 py-2 mt-4 text-white bg-[#2b463c] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  loading ? 'opacity-50 cursor-not-allowed' : ''
                }`}
                disabled={loading}
              >
                {loading ? 'Verifying...' : 'Submit OTP'}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default OtpPage;
